import { DownloadFileProps } from "../components/09-views/00-blocks/Files/Results";

export const canDownloadFile = (props: DownloadFileProps): boolean => (props.loadingFileInitDownload
        || props.fileDownloadResult?.id !== undefined
        || props.loadingFileDownload);
